import React, {Component, Fragment} from 'react';
import { Route, Switch ,withRouter} from 'react-router-dom';

import axios from 'axios';
import {NotificationManager,NotificationContainer} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as profileActions from "./actions/profileActions";
import ScrollUpButton from "react-scroll-up-button";


import './App.css';
import Auth from './components/Auth';
import Main from './components/Main';
import TopBar from './components/Shared/TopBar';
import SideBar from './components/Shared/SideBar';

let timer;

class App extends Component {
    constructor(props){
        super(props);

        // Первичные настройки axios запросов

        axios.interceptors.response.use(response => {
            return response;
        }, error => {

            console.log("error", error);
            console.log("response", error.response);

            if (error.response.status === 401) {
                NotificationManager.error("Нет доступа, необходима авторизация", 'Ошибка', 4000, () => {
                    this.funcLogout();
                    clearTimeout(timer);
                });
                clearTimeout(timer);
                timer = setTimeout(() => {
                        this.funcLogout();
                    },
                    4000);

            } else if ([400,404,500].indexOf(error.response.status) !== -1) {
                let errorText = "Неизвестная ошибка";
                if (error.response.data.error_description) {
                    errorText = error.response.data.error_description;
                } else if (error.response.data.error) {
                    errorText = error.response.data.error;
                } else if(error.response.data.content && error.response.data.content.errorMessage){
                    errorText = error.response.data.content.errorMessage;
                }
                NotificationManager.error(errorText, 'Ошибка', 7000, );
            }
            return Promise.reject(error);
        });
    }
    funcLogout(){
        this.props.history.push("/auth");
    }
  render() {

    return (
        <Fragment>
            <NotificationContainer />
            <ScrollUpButton ShowAtPostion={800}/>
            <TopBar/>
            <div className="page-container">

                <div className="page-content">


                    <SideBar history={this.props.history}/>

                    <div className="content-wrapper">

                        <Switch>
                            <Route exact path="/auth" component={Auth} />
                            <Route path="/" component={Main} />
                        </Switch>

                    </div>


                </div>


            </div>

        </Fragment>
    );
  }
}
//
// function mapStateToProps(state) {
//     return {
//         profile: state.profile
//     }
// }
//
// function mapDispatchToProps(dispath) {
//     return {
//         profileActions: bindActionCreators(profileActions, dispath)
//     }
// }
//
// export default connect(mapStateToProps, mapDispatchToProps)(App);

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js